'use client';

import dynamic from 'next/dynamic';
import { useRef } from 'react';
import { Container, Text } from '@weareconceptstudio/core';

//* Styles
import BoardOfTrusteesTemplateStyle from './style';

//* Components
const TitleAnim = dynamic(() => import('@/animation'), {
	ssr: false,
});
const RowsScrollAnim = dynamic(() => import('@/animation/trigger'), {
	ssr: false,
});
import TrusteeItem from '../components/TrusteeItem';
const Subscribe = dynamic(() => import('@/sections/Subscribe'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '20vh' }} />,
});

const BoardOfTrusteesTemplate = ({ pageData, trusteesData }) => {
	const { content } = pageData;
	const { title } = content;
	const { data } = trusteesData;

	const titleRef = useRef(null);
	const rowsContainerRef = useRef(null);

	return (
		<BoardOfTrusteesTemplateStyle>
			<TitleAnim animRef={titleRef} />

			<RowsScrollAnim
				containerRef={rowsContainerRef}
				selector='.trustee-item'
				isOpacity
			/>

			<Container row>
				<div className={'col-5 col-m-12'}>
					<Text
						ref={titleRef}
						className={'h2 black-900 montserrat-400 trustees-title-wrapper opacity-zero'}>
						{title}
					</Text>
				</div>
				<div className={'col-7 col-m-12'} />
			</Container>

			<Container
				isSection
				row
				ref={rowsContainerRef}
				className={'trustees-container-wrapper'}>
				{data?.map((m) => (
					<div
						key={m.id}
						className={'col-4 col-m-12'}>
						<TrusteeItem
							className='opacity-zero'
							{...m}
						/>
					</div>
				))}
			</Container>

			<Container>
				<Subscribe />
			</Container>
		</BoardOfTrusteesTemplateStyle>
	);
};

export default BoardOfTrusteesTemplate;
